import React from 'react'
import { 
    TitleSection, 
    BorderBottom, 
    WrappCertificates,
    More,
    WrappsCerti,
  } from '../../globalStyle';
import LeftArrow from '../left-arrow/arrow';
  import Certificates from './certificates'

function CertificatesApp(){
    return(
        <>
            <WrappCertificates margin="40px" id="certificates">
            <TitleSection>Certificates</TitleSection>
            <BorderBottom />
            <WrappsCerti>
                <Certificates />
            </WrappsCerti>
            <More to='/certificates-all'>Certificates more</More>
            </WrappCertificates>
        </>
    )
}
export default CertificatesApp;